module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('ap-input-phone', {
    attrs: {
      "input-id": 'inputPhone',
      "error": _vm.error
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.phone)
      }
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "inputPhone"
    }
  }, [_vm._v("Номер телефона "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d53b953", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-4d53b953"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcInputPhone.vue
// module id = 1036
// module chunks = 1